import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { ScrollToTop } from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import Scan from "@/pages/Scan";
import Result from "@/pages/Result";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="App flex min-h-screen flex-col bg-biks-bg text-white">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <div className="flex-1">
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/scan" element={<Scan />} />
                        <Route path="/result/:id" element={<Result />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </div>
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
